import React, { useEffect, useRef, useState } from "react";
import { MoreVertical } from "lucide-react";
import { adminIconBtn } from "@/components/admin/adminUi";

export default function AdminOverflowMenu({ items = [], label = "More actions" }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const visible = items.filter(Boolean);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    const onKey = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    window.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  if (!visible.length) return null;

  return (
    <div className="relative" ref={rootRef}>
      <button
        type="button"
        aria-label={label}
        aria-expanded={open}
        onClick={(event) => {
          event.stopPropagation();
          setOpen((v) => !v);
        }}
        className={adminIconBtn}
      >
        <MoreVertical className="w-5 h-5" />
      </button>
      {open && (
        <div className="admin-menu absolute right-0 bottom-full mb-1 z-20 min-w-[10rem] py-1">
          {visible.map((item) => (
            <button
              key={item.label}
              type="button"
              disabled={item.disabled}
              onClick={(event) => {
                event.stopPropagation();
                setOpen(false);
                item.onClick?.();
              }}
              className="w-full text-left px-3 py-2.5 min-h-11 text-sm font-['Manrope'] text-white/80 hover:bg-white/5 disabled:opacity-40"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
